module.exports = __webpack_public_path__ + "static/media/asv.b09de6eb.jpg";